// Jonu: clicking an already-open "Products" dropdown goes to the full range.
(function () {
  document.addEventListener('click', function (e) {
    var s = e.target.closest('.header__inline-menu details > summary');
    if (!s) return;
    var d = s.parentElement;
    if (d.open && /^products$/i.test(s.textContent.trim())) { e.preventDefault(); window.location.href = '/collections/all'; }
  }, true);
})();
